import { render, staticRenderFns } from "./discount-reg-modal.vue?vue&type=template&id=7af9d847&scoped=true&"
import script from "./discount-reg-modal.vue?vue&type=script&lang=js&"
export * from "./discount-reg-modal.vue?vue&type=script&lang=js&"
import style0 from "./discount-reg-modal.vue?vue&type=style&index=0&id=7af9d847&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af9d847",
  null
  
)

export default component.exports